<template>
  <div class="profile-root">
    <div>
      <!-- 默认头像 -->
      <div class="my-info-container" v-if="!userInfo.nick_name">
        <img class="bg" :src="img" >
        <div class="my-class-info-content">
          <div class="my-avtar" @click="getCodeHandle">
            <a class="my-avatar-link">
              <img :src="avtar" class="actaor" >
            </a>
            <a class="my-unlogin-btn">登录</a>
          </div>
        </div>
      </div>
      <!-- 头像，昵称 -->
      <div class="my-info-container" v-else>
        <img class="bg" :src="img" >
        <div class="my-class-info-content">
          <div class="my-avtar">
            <a class="my-avatar-link">
              <img :src="userInfo.avatar_url" class="actaor" >
            </a>
            <a class="my-unlogin-btn">{{userInfo.nick_name}}</a>
          </div>
        </div>
      </div>
      <!-- 账户信息 -->
      <div>
        <div class="my-count-container">
          <div class="title van-hairline--bottom">
            <Icon style="font-size:28px" name="label-o" />
            <span style="margin-left:8px;">我的账户</span>
          </div>
          <div class="count-info">
            <div class="my-balance">
              <label class="number">{{ count.current_amounts || '0.00' }}</label>
              <label class="my-tip">账户余额</label>
            </div>
            <div class="my-integral">
              <label class="number">{{ count.current_credits || 0 }}分</label>
              <label class="my-tip">账户积分</label>
            </div>
          </div>
        </div>
      </div>
      <!-- 手机号 -->
      <div class="mobile-wrap" style="margin-top:12px;" v-if="userInfo.mobile">
        <div class="cell-item">
          <Icon name="phone-o" />
          <span class="title">手机号</span>
          <span class="mobile">{{userInfo.mobile}}</span>
        </div>
      </div>
      <!-- 变更记录 -->
      <CellGroup style="margin-top:16px;">
        <Cell title="余额变更记录" icon="balance-list-o" size="large" is-link to="/profileList?type=amounts" />
        <Cell title="积分变更记录" icon='todo-list-o' size="large" is-link to="/profileList?type=credits" />
      </CellGroup>
      <!-- 更新手机号 -->
      <div style="margin-top:12px;" v-if="userInfo.mobile">
        <Cell title="更新手机号" @click="clickMobileHandle"  size="large" is-link />
      </div>
      <div class="footer">24h车服务</div>
      <!-- 弹出层 -->
      <Popup v-model="show" closeable :close-on-click-overlay="false" @close="closeHandle" :style="{ width:'85%' }">
        <MobileForm @popupHandle="popupHandle" ref="mobile" />
      </Popup>
    </div>
  </div>
</template>

<script>
import { api,http } from 'utils/'
import Cookies from 'js-cookie'
// import { Dialog } from 'vant';
import MobileForm from './MobileForm'
export default {
  data() {
    return {
      show:false,
      img:require('../../assets/images/profile.png'),
      avtar:require('../../assets/images/base.png'),
      userInfo:{},
      count:{}
    }
  },
  components:{
    MobileForm
  },
  created() {
    document.title = '个人中心'
    if(this.getToken()) {
      // let user = localStorage.getItem('user')
      // this.userInfo = JSON.parse(user)
      this.getUserInfo()
    }else{
      if(location.search !=='') {
        let code = location.search.split('?')[1].split('&')[0].split('=')[1]
        this.postHandle(code)
      }
    }
  },
  methods:{
    async postHandle(code) {
      const res = await http({
        url:api.postCode,
        method:'POST',
        data:{
          code
        }
      })
      if(res && res !== '') {
        this.setToken(res.jwt)
        this.getUserInfo()
        // this.userInfo = res.user
        // localStorage.setItem('user',JSON.stringify(res.user))
      }
    },
    async getUserInfo() {
      const res = await http({
        url:api.getUserInfo,
        headers: {
          'content-type': 'application/json',
          "Authorization": `Bearer ${this.getToken()}`
        }
      })
      if(res) {
        this.userInfo = res.user
        this.count = {
          current_amounts:res.current_amounts,
          current_credits:res.current_credits
        }
        if(res.user.mobile === null || '') {
          this.show = true
          // Dialog.confirm({
          //   title: '提示',
          //   message: '请填写手机号'
          // }).then(() => {
          //   this.$router.push('/mobile')
          // }).catch(() => {
          //   // on cancel
          // });
        console.log(res)
        }
      }
    },
    getCodeHandle() {
      const appid = 'wx37d0d507caacac39'
      const redirect_uri = 'https%3A%2F%2Fcar.techbrew.cn%2F%23%2Fprofile'
      location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
    },
    setToken(token) {
      Cookies.set('JWT', token, { expires: 1 })
    },
    getToken() {
      const token = Cookies.get('JWT')
      if (token) return token
      else return false
    },
    popupHandle() {
      this.show = false
      this.getUserInfo()
    },
    clickMobileHandle() {
      this.show = true
    },
    closeHandle() {
      console.log(this.$refs)
      this.$refs.mobile.closeHandle()
    }
  }
}
</script>

<style lang="less" scoped>
.profile-root{
  height: 100%;
  overflow-y: auto;
}
.my-info-container {
  position: relative;
  z-index: 2;
  height: 1.6rem;
  .bg{
    width: 100%;
    height: 6.4rem;
    margin-top: -4.8rem;
  }
  .actaor{
    width: .65rem;
    height: .65rem;
    border-radius: 100%;
    box-shadow: 0 0.03rem 0.03rem rgba(0,0,0,0.05);
    cursor: pointer;
  }
  .my-class-info-content{
    position: absolute;
    left: 0;
    right: 0;
    bottom: .1rem;
    .my-avtar{
      height: 1rem;
      text-align: center;
      margin: 0 auto;
      width: 100%;
      .my-avatar-link{
        display: inline-block;
        height: .71rem;
        width: .71rem;
        border-radius: 100%;
        padding: .03rem;
        background: rgba(255,255,255,0.5);
      }
      .my-unlogin-btn{
        display: block;
        color: white;
        text-align: center;
      }
    }
  }
}
.my-count-container{
  margin-top: .1rem;
  background-color: #fff;
  .title{
    height: .45rem;
    padding: 0 .12rem;
    color: #4d4d4d;
    font-size: .16rem;
    display: flex;
    align-items: center;
    font-size: 16px;
  }
  .count-info{
    height: .8rem;
    display: flex;
    padding: 0 12px;
    .my-balance{
      flex: 0.5;
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
    }
    .number{
      font-size: 16px;
      text-align: center;
    }
    .my-tip{
      text-align: center;
      margin-top: .05rem;
      color: #888;
      font-size: .12rem;
    }
    .my-integral{
      flex: 0.5;
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
    }
  }
}
.mobile-wrap {
  .cell-item {
    background: #ffffff;
    padding: 12px 16px;
    font-size: 16px;
    .title{
      margin-left: 5px;
    }
    .mobile{
      margin-left: 8px;
      font-size: 14px;
      color: #969799;
    }
  }
}
.footer{
  width: 100%;
  color: #bfbfbf;
  display: flex;
  justify-content: center;
  font-size: 16px;
  margin-top: 30px;
  // position: absolute;
  // bottom: 30px;
}
</style>